// @flow

module.exports = {
  // pagination
  // 'skillacademy/tags': ({
  //   tagName,
  //   page,
  //   pageSize,
  //   sortBy,
  //   sortType,
  // }: {
  //   tagName: string,
  //   page: string,
  //   pageSize: string,
  //   sortBy: string,
  //   sortType: string,
  // }): PaginatedGETResponse<Tag> => {
  //   const pageAsInt = parseInt(page, 10);
  //   const pageSizeAsInt = parseInt(pageSize, 10);
  //   const tags: Tag[] = [
  //     {
  //       tagName: '1tagName1',
  //       tagSerial: 'tgs1',
  //       tagTitle: '1tagTitle1',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //     {
  //       tagName: '1tagName2',
  //       tagSerial: 'tgs2',
  //       tagTitle: '1tagTitle2',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //     {
  //       tagName: '2tagName3',
  //       tagSerial: 'tgs3',
  //       tagTitle: '2tagTitle3',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //     {
  //       tagName: '2tagName4',
  //       tagSerial: 'tgs4',
  //       tagTitle: '2tagTitle4',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //     {
  //       tagName: '3tagName5',
  //       tagSerial: 'tgs5',
  //       tagTitle: '3tagTitle5',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //     {
  //       tagName: '3tagName6',
  //       tagSerial: 'tgs6',
  //       tagTitle: '3tagTitle6',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //     {
  //       tagName: '3tagName5',
  //       tagSerial: 'tgs7',
  //       tagTitle: '3tagTitle5',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //     {
  //       tagName: '3tagName6',
  //       tagSerial: 'tgs8',
  //       tagTitle: '3tagTitle6',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //     {
  //       tagName: '3tagName5',
  //       tagSerial: 'tgs9',
  //       tagTitle: '3tagTitle5',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //     {
  //       tagName: '3tagName6',
  //       tagSerial: 'tgs10',
  //       tagTitle: '3tagTitle6',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //     {
  //       tagName: '3tagName5',
  //       tagSerial: 'tgs11',
  //       tagTitle: '3tagTitle5',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //     {
  //       tagName: '3tagName6',
  //       tagSerial: 'tgs12',
  //       tagTitle: '3tagTitle6',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //     {
  //       tagName: '3tagName5',
  //       tagSerial: 'tgs13',
  //       tagTitle: '3tagTitle5',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //     {
  //       tagName: '3tagName6',
  //       tagSerial: 'tgs14',
  //       tagTitle: '3tagTitle6',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //     {
  //       tagName: '3tagName5',
  //       tagSerial: 'tgs15',
  //       tagTitle: '3tagTitle5',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //     {
  //       tagName: '3tagName6',
  //       tagSerial: 'tgs16',
  //       tagTitle: '3tagTitle6',
  //       tagIconURL: 'https://picsum.photos/50',
  //     },
  //   ];
  //   const sortedTags = tags.sort((a: Tag, b: Tag) => {
  //     if (sortType === 'desc') {
  //       switch (sortBy) {
  //         case 'name':
  //           return a.tagName > b.tagName ? -1 : 1;
  //         case 'title':
  //           return a.tagTitle > b.tagTitle ? -1 : 1;
  //         default:
  //           return 0;
  //       }
  //     } else {
  //       switch (sortBy) {
  //         case 'name':
  //           return a.tagName > b.tagName ? 1 : -1;
  //         case 'title':
  //           return a.tagTitle > b.tagTitle ? 1 : -1;
  //         default:
  //           return 0;
  //       }
  //     }
  //   });
  //   const filteredTags = sortedTags.filter((tag) =>
  //     tag.tagName.includes(tagName),
  //   );
  //   const isFilterActive = tagName && tagName !== '';
  //   let paginatedTags = [];
  //   let totalPage = 0;
  //   const lowerIndex = (pageAsInt - 1) * pageSizeAsInt;
  //   const upperIndex = pageAsInt * pageSizeAsInt;
  //   if (isFilterActive) {
  //     paginatedTags = filteredTags.filter((tag, index) => {
  //       return index >= lowerIndex && index < upperIndex;
  //     });
  //     totalPage = filteredTags.length / pageSizeAsInt;
  //   } else {
  //     paginatedTags = sortedTags.filter((tag, index) => {
  //       return index >= lowerIndex && index < upperIndex;
  //     });
  //     totalPage = tags.length / pageSizeAsInt;
  //   }
  //   return {
  //     data: {
  //       currentPage: pageAsInt,
  //       items: paginatedTags,
  //       totalItems: paginatedTags.length,
  //       totalPage: totalPage,
  //     },
  //     status: 'success',
  //     message: 'success',
  //   };
  // },
};
